import api from './api';

export class ImportExportService {
  /**
   * Import data from an Excel file.
   * @param estateId - UUID of the estate.
   * @param file - The Excel file to import.
   * @returns A promise that resolves when the import is complete.
   */
  static async importData(estateId: string, file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);

    try {
      await api.post(`/import-export/import/${estateId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error: any) {
      console.error('Error importing data:', error);
      throw new Error(error.response?.data?.message || 'Failed to import data.');
    }
  }

  /**
   * Export data to an Excel file.
   * @param estateId - UUID of the estate.
   * @returns A promise that resolves to a Blob containing the Excel file.
   */
  static async exportData(estateId: string): Promise<Blob> {
    try {
      const response = await api.get(`/import-export/export/${estateId}`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error: any) {
      console.error('Error exporting data:', error);
      throw new Error(error.response?.data?.message || 'Failed to export data.');
    }
  }
}
